import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { AddRoom, Feature, RoomCommands, RoomProperties, ViError } from '../../../projects/client';
import { UpdateFeatureConfig } from '../_models/feature.model';
import { FeatureProperties, ReplaceGatewayFormData } from './installation-features.models';

export namespace InstallationFeaturesActions {
  export const fetchFeatures = createActionGroup({
    source: 'INSTALLATION FEATURES Get',
    events: {
      attempt: emptyProps(),
      success: props<{ features: Feature<unknown, unknown>[] }>(),
      error: props<{ error: unknown }>(),
    },
  });

  export const updateFeature = createActionGroup({
    source: 'INSTALLATION FEATURES Update feature',
    events: {
      attempt: props<FeatureProperties>(),
      success: props<{
        featureName: string;
        config?: UpdateFeatureConfig;
      }>(),
      error: props<{ featureName: string; property: string | string[]; error: unknown }>(),
    },
  });

  export const updateMultipleFeatures = createActionGroup({
    source: 'INSTALLATIONFEATURES Update multiple features',
    events: {
      attempt: props<{
        features: FeatureProperties[];
      }>(),
      success: props<{
        featureNames: string[];
      }>(),
      error: props<{ error: ViError }>(),
    },
  });

  export const fetchFeaturesForInstallationGateways = createActionGroup({
    source: 'INSTALLATION FEATURES Get features for all installation gateways',
    events: {
      attempt: emptyProps(),
      success: props<{ gatewaySerials: string[]; features: Feature<unknown, unknown>[] }>(),
      error: emptyProps(),
      aborted: props<{ installationId: number }>(), // no gateways on this installation
    },
  });
  export const upsertManyFeatures = createAction(
    '[INSTALLATION FEATURES] Upsert ws values',
    props<{ features: Feature<unknown, unknown>[] }>()
  );
  export const removeManyFeatures = createAction(
    '[INSTALLATION FEATURES] Remove many',
    props<{ featureKeys: string[] }>()
  );
  export const removeAllFeatures = createAction('[INSTALLATION FEATURES] Remove all');
  export const getMockedFeature = createAction(
    '[INSTALLATION FEATURES] Get mocked feature',
    props<{ path: string; featureName: string }>()
  );
  export const updateRooms = createAction(
    '[INSTALLATION FEATURES] Update rooms',
    props<{ rooms: Feature<RoomProperties, RoomCommands>[] }>()
  );
  export const updateAddRoomInfo = createAction(
    '[INSTALLATION FEATURES] Update add room info',
    props<{ room: AddRoom }>()
  );
  export const setReplaceGatewayFormData = createAction(
    '[INSTALLATION FEATURES] Set form replace gateway data',
    props<{
      formData: ReplaceGatewayFormData;
    }>()
  );

  export const updateReplaceGateway = createActionGroup({
    source: '[INSTALLATION FEATURES] Update replace gateway data',
    events: {
      attempt: emptyProps(),
      success: emptyProps(),
      error: props<{ error: ViError }>(),
    },
  });
}
